export enum ShipmentTab {
  WORK_ORDERS = 'Work Orders',
}
